import { computed, ref } from 'vue';
import { defineStore } from 'pinia';
import type { PhotoItem } from '@/types';
import type { GetPhoto200Response } from '@/utils/api/api';

type TakeRequest = {
  request: boolean;
  photoId: string | undefined;
};

/**
 * 画像撮影関連のStore
 */
export const usePhotoStore = defineStore('photo', () => {
  /** 写真撮影要求（自身が撮影を要求したかどうか） */
  const takeRequest = ref<TakeRequest>({ request: false, photoId: undefined });
  /**
   * 写真撮影要求イベント受信
   * @param photoId 写真ID
   */
  const onEventRequestTakePhoto = (photoId: string): void => {
    // 自身が撮影を要求した場合は、写真IDを保存する
    if (takeRequest.value.request) {
      takeRequest.value.photoId = photoId;
    }
  };

  /**
   * 写真撮影完了イベント受信
   */
  const onEventCompleteTakePhoto = (): void => {
    takeRequest.value = { request: false, photoId: undefined };
  };

  /** 画像共有中の写真 */
  const sharedPhoto = ref<PhotoItem | undefined>(undefined);

  /**
   * 画像共有開始イベント受信
   * @param photoId 写真ID
   * @param photo 画像
   */
  const onEventStartPhotoSharing = (photoId: string, photo: GetPhoto200Response): void => {
    sharedPhoto.value = { photoId: photoId, photo: photo };
  };

  /**
   * 画像共有開始イベント受信
   * @param photoId 写真ID
   */
  const onEventFinishPhotoSharing = (photoId: string): void => {
    if (photoId === sharedPhoto.value?.photoId) {
      sharedPhoto.value = undefined;
    }
  };

  /**
   * Storeの初期化
   */
  const clear = (): void => {
    takeRequest.value = { request: false, photoId: undefined };
    sharedPhoto.value = undefined;
  };

  return {
    takeRequest,
    onEventRequestTakePhoto,
    onEventCompleteTakePhoto,
    sharedPhoto,
    onEventStartPhotoSharing,
    onEventFinishPhotoSharing,
    clear
  };
});
